<template>
    <div class="relative">
        <div v-if="isPlaying" class="aspect-w-16 aspect-h-9">
            <VideoEmbed :src="videoUrl" :params="{autoplay: autoplay}" />
        </div>
        <template v-else>
            <div v-if="corner" class="floating w-24 h-24 bg-primary absolute rounded-lg z-0 -top-3 -left-3"></div>
            <ResponsiveImage
                :name="title"
                class="rounded-xl z-20 relative w-full"
                :images="backgroundImage"
                :alt="title" />
            <button
                :aria-label="$t('Play')"
                class="bg-black text-primary w-14 h-14 rounded-full flex items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 focus:outline-none transition hover:scale-110 duration-300 ease-in-out z-30"
                @click="onPlay">
                <PlayIcon class="w-5 h-5 ml-1" />
            </button>
            <div class="bg-secondary-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
        </template>
    </div>
</template>
<script setup>
import {ref} from 'vue';
import {ResponsiveImage} from '@/Components/Media';
import VideoEmbed from '@/Components/Media/Partials/VideoEmbed.vue';
import PlayIcon from '@/images/components/play_icon.svg';

defineProps({
    title: {
        type: String,
        required: true,
    },
    backgroundImage: {
        type: [String, Array],
        required: true,
    },
    videoUrl: {
        type: String,
        required: true,
    },
    autoplay: {
        type: Boolean,
        default: true,
    },
    corner: {
        type: Boolean,
        default: false,
    },
});

const isPlaying = ref(false);

const onPlay = () => {
    isPlaying.value = true;
};
</script>
